export default __webpack_public_path__ + "static/media/Tasset of the Invincible.64d8d9d8.jpg";